// extracted by mini-css-extract-plugin
export var animationContainer = "_hc-0";
export var asteriskIcon = "_hc-8";
export var conversationLeftSection = "_hc-4";
export var conversationListItem = "_hc-3";
export var conversationMiddleSection = "_hc-5";
export var conversationRightSection = "_hc-6";
export var detailsContent = "_hc-1";
export var listContainer = "_hc-7";
export var modalContent = "_hc-2";